// extracted by mini-css-extract-plugin
export var active = "DesktopCategoryFilter-module--active--630ce";
export var arrow = "DesktopCategoryFilter-module--arrow--56a95";
export var clearButton = "DesktopCategoryFilter-module--clearButton--97a48";
export var closeIcon = "DesktopCategoryFilter-module--closeIcon--76795";
export var dropdown = "DesktopCategoryFilter-module--dropdown--69e5a";
export var fadeInUp = "DesktopCategoryFilter-module--fadeInUp--db2e1";
export var item = "DesktopCategoryFilter-module--item--b8b6e";
export var list = "DesktopCategoryFilter-module--list--9ffb4";
export var root = "DesktopCategoryFilter-module--root--da9fb";
export var subitem = "DesktopCategoryFilter-module--subitem--9b39c";
export var sublist = "DesktopCategoryFilter-module--sublist--3206e";
export var title = "DesktopCategoryFilter-module--title--b7367";